import axios from 'axios';

const PRODUCTION_API = 'https://api.iskenderun.bel.tr';
const LOCAL_DEVELOPMENT_API = 'https://api.iskenderun.bel.tr';
const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '0.0.0.0']);
const DEVELOPMENT_MODE = process.env.NODE_ENV === 'development';

const isIpv4Address = (value) => /^\d{1,3}(\.\d{1,3}){3}$/.test(value || '');

const isLocalBrowserHost = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  const host = (window.location.hostname || '').trim().toLowerCase();
  if (!host) {
    return false;
  }

  return LOCAL_HOSTS.has(host) || host.endsWith('.local') || isIpv4Address(host);
};

const normalizeConfiguredUrl = (value) => {
  const trimmedValue = (value || '').trim();
  if (!trimmedValue) {
    return '';
  }

  const withoutApiSuffix = trimmedValue.endsWith('/api')
    ? trimmedValue.slice(0, -4)
    : trimmedValue;

  return withoutApiSuffix.replace(/\/$/, '');
};

const isValidAbsoluteUrl = (value) => {
  try {
    new URL(value);
    return true;
  } catch {
    return false;
  }
};

const resolveBaseUrl = () => {
  const raw = process.env.REACT_APP_API_URL || '';
  const normalizedEnvUrl = normalizeConfiguredUrl(raw);
  const localBrowserHost = isLocalBrowserHost();

  if (DEVELOPMENT_MODE && localBrowserHost) {
    if (!normalizedEnvUrl) {
      console.warn('[api] Development local calisma algilandi, varsayilan localhost backend kullaniliyor:', LOCAL_DEVELOPMENT_API);
      return LOCAL_DEVELOPMENT_API;
    }

    if (!isValidAbsoluteUrl(normalizedEnvUrl)) {
      console.warn('[api] Development local env gecersiz, localhost backend kullaniliyor:', raw);
      return LOCAL_DEVELOPMENT_API;
    }

    if (normalizedEnvUrl === PRODUCTION_API) {
      console.warn('[api] Development local calisma algilandi, production env yok sayildi:', normalizedEnvUrl);
      return LOCAL_DEVELOPMENT_API;
    }

    return normalizedEnvUrl;
  }

  if (normalizedEnvUrl) {
    if (isValidAbsoluteUrl(normalizedEnvUrl)) {
      return normalizedEnvUrl;
    }

    console.warn('[api] REACT_APP_API_URL gecersiz, fallback secilecek:', raw);
  }

  if (localBrowserHost) {
    console.warn('[api] Local calisma algilandi, localhost backend kullaniliyor:', LOCAL_DEVELOPMENT_API);
    return LOCAL_DEVELOPMENT_API;
  }

  console.warn('[api] REACT_APP_API_URL bos/gecersiz, production URL kullaniliyor:', PRODUCTION_API);
  return PRODUCTION_API;
};

const BASE_URL = resolveBaseUrl();
console.info('[api] BASE_URL:', BASE_URL);

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response) {
      console.error('API error:', {
        endpoint: error.config?.url,
        status: error.response.status,
        data: error.response.data
      });

      if (error.response.status === 401) {
        const headers = error.response.headers || {};
        const headerValue = headers['x-session-revoked'] ?? headers['X-Session-Revoked'];
        const isRevoked = (headerValue ?? '').toString().toLowerCase() === 'true';
        const message = isRevoked
          ? 'Oturumunuz sonlandirildi. Lutfen tekrar giris yapin.'
          : 'Oturum suresi doldu. Lutfen tekrar giris yapin.';

        localStorage.clear();
        window.location.href = '/login';
        return Promise.reject(new Error(message));
      }
    } else if (error.request) {
      console.error('Network error:', {
        endpoint: error.config?.url,
        message: error.message
      });
    } else {
      console.error('Request error:', error.message);
    }

    return Promise.reject(error);
  }
);

export { BASE_URL };
export default api;
